// libs
import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// components
import Navigation from "../../components/navbar";
import "../../assets/css/style.css";
import CardBlock from "./card";
import ajaxCall from '../../utils/ajaxcall';
import config from '../../config';

function Dashboard({ token, orgInfo }) {
	const [kpiData, setKpiData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		async function fetchKpis() {
			if (!token) return;
			const apiCall = await ajaxCall.getCall(`${config.api.generic}/kpi/dashboard`, {}, token, { "Domain": "vyayata" });
			if (apiCall?.status && apiCall.context?.message?.data) {
				setKpiData(apiCall.context.message.data);
				setIsError(false);
			} else {
				setIsError(true);
			}
			setIsLoading(false);
		}
		// fetchKpis();
	}, [token]);

	const formatCurrency = (val) => {
		if (val === undefined || val === null) return '0';
		return new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(val);
	};

	return (
		<>
			<Navigation orgInfo={orgInfo} />
			<Container>
				<Row className="mb-4 mt-5">
					<Col xl="3" lg="6">
						<CardBlock
							title="Total Products"
							value={0}
							icon="box"
							isLoading={isLoading}
						/>
					</Col>
					<Col xl="3" lg="6">
						<CardBlock
							title="In Stock SKUs"
							value={0}
							icon="boxes"
							isLoading={isLoading}
						/>
					</Col>
					<Col xl="3" lg="6">
						<CardBlock
							title="Total Customers"
							value={0}
							icon="users"
							isLoading={isLoading}
						/>
					</Col>
					<Col xl="3" lg="6">
						<CardBlock
							title="Total Orders"
							value={0}
							icon="cart"
							isLoading={isLoading}
						/>
					</Col>
				</Row>
				<Row className="mb-4">
					<Col xl="3" lg="6">
						<CardBlock
							title="Total Revenue (Paid)"
							value={formatCurrency(0)}
							prefix="₹ "
							icon="rupee"
							isLoading={isLoading}
						/>
					</Col>
					<Col xl="3" lg="6">
						<CardBlock
							title="Items Sold"
							value={0}
							icon="chart"
							isLoading={isLoading}
						/>
					</Col>
					<Col xl="3" lg="6">
						<CardBlock
							title="Low Stock Alert"
							value={0}
							icon="warning"
							isLoading={isLoading}
						/>
					</Col>
					<Col xl="3" lg="6">
						<CardBlock
							title="Active Offer Codes"
							value={0}
							icon="ticket"
							isLoading={isLoading}
						/>
					</Col>
				</Row>
			</Container>
		</>
	);
}

export default Dashboard;
